import { render, staticRenderFns } from "./follow-up-managers.vue?vue&type=template&id=46bb9434"
import script from "./follow-up-managers.vue?vue&type=script&lang=js"
export * from "./follow-up-managers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports